import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  state = { hasError: false, tries: 0, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("EFFERVESCENCE admin crash:", error, info?.componentStack);
  }

  retry = () => this.setState((s) => ({ hasError: false, error: null, tries: s.tries + 1 }));

  goHome = () => {
    this.setState({ hasError: false });
    if (this.props.onHome) this.props.onHome();
    else window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="admin-error-boundary"
          className={`${this.props.fullPage ? "min-h-screen bg-black" : "min-h-[60vh]"} flex flex-col items-center justify-center text-center px-6`}
        >
          <AlertTriangle className="w-8 h-8 text-muted-eff mb-6" />
          <div className="text-[10px] tracking-[0.3em] uppercase text-muted-eff mb-3">Erreur</div>
          <h2 className="font-display text-3xl md:text-4xl mb-4">Une erreur est survenue</h2>
          <p className="text-muted-eff text-sm max-w-md mb-8">
            Cette section a rencontré un problème. Vos autres données sont intactes — réessayez ou revenez au dashboard.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <button
              data-testid="error-retry"
              onClick={this.retry}
              className="text-xs tracking-widest uppercase px-6 py-3 bg-white text-black hover:bg-[#dddddd] transition-colors duration-300"
            >
              Réessayer
            </button>
            <button
              data-testid="error-home"
              onClick={this.goHome}
              className="text-xs tracking-widest uppercase px-6 py-3 border border-[#292929] hover:border-white transition-colors duration-300"
            >
              Retour au dashboard
            </button>
          </div>
          {this.state.error && (
            <details data-testid="error-details" className="mt-8 max-w-lg w-full text-left">
              <summary className="text-[10px] tracking-[0.2em] uppercase text-muted-eff cursor-pointer">Détails techniques</summary>
              <pre className="mt-3 text-[11px] text-[#888888] whitespace-pre-wrap break-words max-h-48 overflow-auto">
                {String(this.state.error?.message || this.state.error)}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return <div key={this.state.tries}>{this.props.children}</div>;
  }
}
